import ApiService from "../../../core/services/ApiService";

class UserAccessService extends ApiService {
  basePath: string = "/api";

  async getUserDetailsById<T>(id: number) {
    return this.makeRequest<T>(
      `${this.basePath}/deliverable-user-access/${id}`,
      {
        method: "get",
        extractData: true,
      },
    );
  }

  async updateUserDetailsById<T>(id: number, data: any) {
    return this.makeRequest<T>(
      `${this.basePath}/deliverable-user-access/${id}`,
      {
        method: "put",
        data,
        extractData: true,
      },
    );
  }

  async getUserWithoutAccess<T>(id: number) {
    return this.makeRequest<T>(
      `${this.basePath}/deliverable/user-without-access/${id}`,
      {
        method: "get",
        extractData: true,
      },
    );
  }

  async updateUserWithoutAccess<T>(id: number, data: any): Promise<T> {
    return this.makeRequest<T>(
      `${this.basePath}/deliverable-user-access/${id}`,
      {
        method: "post",
        data,
        extractData: true,
      },
    );
  }
}

export default UserAccessService;
